export default class formConfig {
  // 项目负责人资质（项目负责人注册专业一览）
  static configList() {
    return [
      {
        title: "项目负责人资质",
        name: "1",
        icon: "",
        tip: "（项目负责人注册专业详情）",
        formConfigList: [
          {
            label: "专业编码：",
            type: "input",
            value: "typeCode",
            placeholder: "请输入",
            maxlength: 10,
            rule: {
              required: true,
              message: "请填写专业编码",
              trigger: "blur"
            }
          },
          {
            label: "专业名称：",
            type: "input",
            value: "typeName",
            placeholder: "请输入",
            maxlength: 150,
            rule: {
              required: true,
              message: "请填写专业名称",
              trigger: "blur"
            }
          },
          {
            label: "注册类型：",
            type: "select",
            value: "tradeType",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201507131626360048"
            },
            rule: {
              required: true,
              message: "请选择注册类型",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
  // 项目负责人资质（项目负责人注册等级一览）
  static regTradeLevel() {
    return [
      {
        title: "项目负责人资质",
        name: "1",
        icon: "",
        tip: "（项目负责人注册等级详情）",
        formConfigList: [
          {
            label: "注册类型：",
            type: "select",
            value: "tradeType",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201507131626360048"
            },
            rule: {
              required: true,
              message: "请选择注册类型",
              trigger: "blur"
            }
          },
          {
            label: "注册等级编码：",
            type: "input",
            value: "typeLevelNum",
            placeholder: "请输入",
            maxlength: 10,
            rule: {
              required: true,
              message: "请填写注册等级编码",
              trigger: "blur"
            }
          },
          {
            label: "注册等级名称：",
            type: "input",
            value: "typeLevelName",
            placeholder: "请输入",
            maxlength: 300,
            rule: {
              required: true,
              message: "请填写注册等级名称",
              trigger: "blur"
            }
          },
          {
            label: "注册等级编号：",
            type: "input",
            value: "typeLevelNo",
            maxlength: 2,
            placeholder: "请输入数字",
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              },
              {
                pattern: /^([1-9]\d*|0)(\.\d{1,6})?$$/,
                message: "请输入数字"
              }
            ]
          },
        ]
      },
    ];
  }
}
